<script lang="ts">
	import Icon from './Icon.svelte';

	let {
		onEdit,
		onDelete,
		onView,
		editTitle = 'Edit',
		deleteTitle = 'Delete',
		viewTitle = 'View',
		showActions = true
	}: {
		onEdit?: () => void;
		onDelete?: () => void;
		onView?: () => void;
		editTitle?: string;
		deleteTitle?: string;
		viewTitle?: string;
		showActions?: boolean;
	} = $props();
</script>

{#if showActions && (onEdit || onDelete || onView)}
	<div class="flex items-center gap-1">
		{#if onView}
			<button
				onclick={onView}
				class="rounded-lg p-2 text-gray-400 transition-colors hover:bg-gray-50 hover:text-gray-600"
				title={viewTitle}
			>
				<Icon name="eye" size={16} />
			</button>
		{/if}
		{#if onEdit}
			<button
				onclick={onEdit}
				class="rounded-lg p-2 text-gray-400 transition-colors hover:bg-blue-50 hover:text-blue-600"
				title={editTitle}
			>
				<Icon name="pencil" size={16} />
			</button>
		{/if}
		{#if onDelete}
			<button
				onclick={onDelete}
				class="rounded-lg p-2 text-gray-400 transition-colors hover:bg-red-50 hover:text-red-600"
				title={deleteTitle}
			>
				<Icon name="trash" size={16} />
			</button>
		{/if}
	</div>
{/if}
